export function generateVendorPortalToken() {
  const rand = Math.random().toString(36).slice(2, 10);
  const time = Date.now().toString(36);
  return `vt-${rand}${time}`;
}

export function vendorPortalPath(token) {
  return `/vendor/portal/${token}`;
}

export function vendorPortalUrl(token) {
  if (typeof window === 'undefined' || !token) return vendorPortalPath(token);
  return `${window.location.origin}${vendorPortalPath(token)}`;
}
